const environmentHelper = {
    getPageBaseURL() {
        return process.env.REACT_APP_WEBSITE_URL || ""
    },
    getHost(): string {
        return process.env.REACT_APP_HOST || ""
    },
    getPublicHost(): string {
        return process.env.REACT_APP_PUBLIC_HOST || ""
    },
    getEnv(): string {
        return process.env.REACT_APP_ENV || "";
    },
    getGMCNgineGAView() {
        return {
            query: {
                ids: process.env.REACT_APP_GMCNGINE_GA_VIEW || ""
            }
        }
    },
    getFindGAView() {
        return {
            query: {
                ids: process.env.REACT_APP_FIND_GA_VIEW || ""
            }
        }
    },
    getRekognitionImageRoot(): string {
        return `https://s3.amazonaws.com/gmcngine-${this.getEnv()}-rekognition`;
    },
    getRecognitionURL(): string {
        return process.env.REACT_APP_RECOGNITION_URL || ""
    },
    getETLURL(): string {
        return process.env.REACT_APP_ETL_URL || ""
    },
    getCognitoConfig() {
        return {
            region: process.env.REACT_APP_Region || "",
            cognitoRegion: process.env.REACT_APP_CognitoRegion || "",
            userPoolId: process.env.REACT_APP_UserPoolId || "",
            clientId: process.env.REACT_APP_ClientId || "",
            identityPoolId: process.env.REACT_APP_IdentityPoolId || "",
            accessJwtToken: process.env.REACT_APP_AccessJwtToken || ""
        }
    },
    getGoogleAnalyticsTrackId(): string {
        return process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKID || ""
    },
    getReactMapboxGlConfig(): string {
        return process.env.REACT_APP_MapboxGl || ""
    },
    getFirebase() {
        return {
            apiKey: process.env.REACT_APP_ApiKey || "",
            authDomain: process.env.REACT_APP_AuthDomain || "",
            databaseURL: process.env.REACT_APP_DatabaseURL || "",
            projectId: process.env.REACT_APP_ProjectId || "",
            storageBucket: process.env.REACT_APP_StorageBucket || "",
            messagingSenderId: process.env.REACT_APP_MessagingSenderId || "",
            appId: process.env.REACT_APP_AppId || "",
            measurementId: process.env.REACT_APP_MeasurementId || "",
        }
    }
};

export default environmentHelper;



// WEBPACK FOOTER //
// ./src/share/utils/environmentHelper.ts